<template>
  <details @toggle="collapsed = !collapsed" :open="collapsed">
    <summary>
      <span v-html="question"></span>
      <BaseIcon icon="keyboard-arrow-up" class="arrow" v-if="collapsed" />
      <BaseIcon icon="keyboard-arrow-down" class="arrow" v-else />
    </summary>
    <span v-html="answer"></span>
  </details>
</template>
<script setup lang="ts">
defineProps<{
  question: string;
  answer: string;
}>();

const collapsed = ref(false);
</script>
<style lang="scss" scoped>
details {
  background-color: $light-95;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid $light-80;
}

details summary {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  align-items: center;
  list-style: none;
  &::-webkit-details-marker {
    display: none;
  }
}

.arrow {
  color: $dark-50;
  font-size: 3rem;
  width: 3rem;
  height: 3rem;
}

details :deep(a) {
  color: $gold;
}
</style>
